import styles from './index.module.css';
import Image02 from '../../../assets/images/about_us.png';

const AboutUs = () => {

  return (
    <div className={styles.resultsContainer} id='about'>
      <div className={`main-container`}>
        <div className={`container-content`}>
          <div className={styles.homeHeader}>
            <h1 className={styles.listingTitle}>Who Are We</h1>
          </div>
          <div className={styles.cardSection}>
            <div className={styles.leftSec}>
              <p className={styles.leftText}>
                Welcome to Studyhub, an innovative educational platform that aims
                to empower and develop skilled individuals for the betterment of Sri
                Lanka. Our mission is to provide learners with the necessary knowledge
                and skills to succeed in society.
              </p>
              <img src={Image02} alt='Person' className={styles.leftImg} />
            </div>
            <div className={styles.rightSec}>
              <p className={styles.aboutContent}>
                At Studyhub, we believe that education can transform lives and
                communities. The purpose of our website is to
                revolutionize the educational landscape of Sri Lanka by providing a
                dynamic platform where individuals can access high-quality learning
                resources, engage with expert mentors, and pursue personal and
                professional growth. We are committed to constantly improving our
                offerings.
              </p>
              <ul className={styles.aboutList}>
                <li><strong>Wide Course Selection</strong> – Learn from dozens of expert-created courses across multiple fields.</li>
                <li><strong> Personalized Dashboard</strong> – Track your progress, completed lessons, and upcoming activities.</li>
                <li><strong>Easy Learning Experience</strong> – Enjoy clear video lessons, notes, and structured modules.</li>
                <li><strong>Secure Payments & Instant Access</strong> – Purchase courses safely and start learning immediately.</li>
                <li><strong>Learn Anywhere</strong> – Access all your courses anytime.</li>
                <li><strong>Community & Support</strong> – Get help, ask questions, and connect with instructors easily.</li>
                <li><strong>Progress Insights</strong> – View detailed analytics about your learning journey and achievements.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;